import { inject } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { WINDOW } from '@tvd/cdk/browser';
import { Storage } from '@tvd/utils/storage';

export const authGuard = () => {
  const auth = inject(AuthService);
  if (!auth.token()) {
    // When offline with a stored refresh token, the user was previously
    // authenticated but the token refresh failed due to network.
    // Don't logout — let them see cached content until connectivity returns.
    const storage = inject(Storage);
    const winRef = inject(WINDOW);
    if (!winRef.navigator.onLine && storage.get('REFRESH_TOKEN')) {
      return true;
    }
    auth.logout();
    return false;
  }
  return true;
};

export const redirectFromAuthGuard = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.token()) {
    return router.createUrlTree(['/']);
  }
  return true;
};
